import { makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import CardMenu from "@saleor/components/CardMenu";
import Container from "@saleor/components/Container";
import PageBreadcrumbNavigation from "@saleor/components/PageBreadcrumbNavigation/PageBreadcrumbNavigation";
import PageHeader from "@saleor/components/PageHeader";
import SearchBar from "@saleor/components/SearchBar";
import useNavigator from "@saleor/hooks/useNavigator";
import { sectionNames } from "@saleor/intl";
import React from "react";
import { FormattedMessage, useIntl } from "react-intl";

import {
  PageListProps,
  SearchPageProps,
  SortPage,
  TabPageProps
} from "../../../types";
import { PermissionGroupList_permissionGroups_edges_node } from "../../types/PermissionGroupList";
import {
  PermissionGroupListUrlSortField,
  permissionGroupMultiFactorAuthenticationUrl
} from "../../urls";
import PermissionGroupList from "../PermissionGroupList";

export interface PermissionGroupListPageProps
  extends PageListProps,
    SearchPageProps,
    TabPageProps,
    SortPage<PermissionGroupListUrlSortField> {
  permissionGroups: PermissionGroupList_permissionGroups_edges_node[];
  onBack: () => void;
  onDelete: (id: string) => void;
  onRowClick: (id: string) => () => void;
}

const PermissionGroupListPage: React.FC<PermissionGroupListPageProps> = ({
  onAdd,
  onBack,
  currentTab,
  initialSearch,
  onSearchChange,
  onAll,
  onTabChange,
  onTabDelete,
  onTabSave,
  tabs,
  ...listProps
}) => {
  const intl = useIntl();

  const breadcrumbDirectory = [
    {
      name: "User Types"
    }
  ];

  const useStyles = makeStyles(
    theme => ({
      createUserTypeButton: {
        margin: theme.spacing(0, 3)
      }
    }),
    { name: "PermissionGroupListPage" }
  );

  const classes = useStyles(listProps);
  const navigate = useNavigator();

  return (
    <Container>
      <PageBreadcrumbNavigation items={breadcrumbDirectory} />
      <PageHeader title={intl.formatMessage(sectionNames.usertypes)}>
        <Button
          color="primary"
          variant="contained"
          onClick={onAdd}
          id="createUserTypesBtn"
          className={classes.createUserTypeButton}
        >
          <FormattedMessage
            defaultMessage="create user types"
            description="button"
          />
        </Button>
        <CardMenu
          menuItems={[
            {
              label: intl.formatMessage({
                defaultMessage: "Multi-Factor Authentication",
                description: "multi-factor authentication, button"
              }),
              onSelect: () =>
                navigate(permissionGroupMultiFactorAuthenticationUrl),
              testId: "multiFactorAuthentication"
            },
            {
              label: intl.formatMessage({
                defaultMessage: "User Type Permissions",
                description: "user type permissions, button"
              }),
              onSelect: () => null,
              testId: "userTypePermissions"
            }
          ]}
        />
      </PageHeader>
      <Card>
        <SearchBar
          allTabLabel={intl.formatMessage({
            defaultMessage: "All ",
            description: "tab name"
          })}
          currentTab={currentTab}
          initialSearch={initialSearch}
          searchPlaceholder={intl.formatMessage({
            defaultMessage: "Search User Types"
          })}
          tabs={tabs}
          onAll={onAll}
          onSearchChange={onSearchChange}
          onTabChange={onTabChange}
          onTabDelete={onTabDelete}
          onTabSave={onTabSave}
        />

        <PermissionGroupList {...listProps} />
      </Card>
    </Container>
  );
};
PermissionGroupListPage.displayName = "PermissionGroupListPage";
export default PermissionGroupListPage;
